export default __webpack_public_path__ + "static/4-5ecdd6d61dbb0a613724ba193e15ca35.webp";